module.exports = __webpack_public_path__ + "img/add-image11.0c71f34a.png";